module.exports = __webpack_public_path__ + "static/img/qh1-2.fc29e83.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/qh1-2.png
// module id = 904
// module chunks = 0